const HTML_ESCAPE = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;',
};

type HTMLChar = keyof typeof HTML_ESCAPE;

const REGEX = new RegExp(`[${Object.keys(HTML_ESCAPE).join('')}]`, 'g');

const escapeChar = (char: string): string => HTML_ESCAPE[char as HTMLChar] || '';

export const escape = (text: string = ''): string => {
    if (!REGEX.test(text)) {
        return text;
    }

    return text.replace(REGEX, escapeChar);
};
